<!-- simple Modal for confirming actions -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { onMount } from "svelte";
    import { fade } from "svelte/transition";
    import { createEventDispatcher } from "svelte";
    export let show_modal;
    export let title;
    const dispatch = createEventDispatcher();
    let is_button_disabled = false;

    function confirm() {
        timeout_button();
        dispatch("confirm");
        show_modal = false;
    }

    function cancel() {
        dispatch("cancel");
        show_modal = false;
    }

    function timeout_button(){
        is_button_disabled = true;
        setTimeout(() => {
            is_button_disabled = false;
        }, 500);
    }
</script>

{#if show_modal}
    <div
        class="svelte-modal svelte-backdrop"
        id="confirm_modal"
        tabindex="-1"
        role="dialog"
        display="flex"
        transition:fade={{ duration: 150 }}
        on:mousedown|self={() => (show_modal = false)}
        on:keydown={(e) => {
            if (e.key === "Escape") {
                show_modal = false;
            }
        }}
    >
        <div
            class="svelte-modal-dialog svelte-modal-dialog-centered"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmTitle">
                        {title}
                    </h5>
                </div>
                <div class="modal-footer" id="edit">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        on:click={() => (show_modal = false)}>Abbrechen</button
                    >
                    <button
                        type="button"
                        class="btn btn-primary"
                        disabled={is_button_disabled}
                        on:click={() => confirm()}>Bestätigen</button
                    >
                </div>
            </div>
        </div>
    </div>
{/if}
